import { UnstyledButton } from '@mantine/core';
import { useDispatch, useSelector } from 'react-redux';
import RelevaLogo from '../../logo_small.png';
import { setChatOpen } from '../../store/chatSlice';
import ChatBotToggle from './ChatBotToggle';

/* Lucy has two launch variants: this always-visible floating bubble (paired with the
   right padding gutter on .domain-page-body > .App so content never sits under it at
   any scroll position), and the "Ask a Question" item in the navbar help menu
   (GetHelpButton). Both drive the shared chat.isChatOpen state; remove the bubble
   render below to go back to the menu-toggled-only variant. */
const LucyLauncher = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.chat.isChatOpen);

  return (
    <>
      <ChatBotToggle isOpen={isOpen} setIsOpen={(open) => dispatch(setChatOpen(open))} />
      {!isOpen && (
        <UnstyledButton
          className="chat-bot-bubble"
          aria-label="Chat with Lucy"
          onClick={() => dispatch(setChatOpen(true))}
        >
          <img src={RelevaLogo} alt="" />
        </UnstyledButton>
      )}
    </>
  );
};

export default LucyLauncher;
